<template>
  <div class="amenities bg-white FoundersGrotesk">
    <section class="container-xl">
      <b-row>
        <b-col cols="12" md="6" class="p-0">
          <div v-for="(link, index) in footerColumn1" :key="index">
            <div class="lg-text">{{ link.text }}</div>
          </div>
        </b-col>
        <b-col cols="6" md="3" class="text-left p-0">
          <div v-for="(link, index) in footerColumn2" :key="index">
            <div class="amen-text">{{ link.text }}</div>
          </div>
        </b-col>
        <b-col cols="6" md="3" class="text-left">
          <div v-for="(link, index) in footerColumn3" :key="index">
            <div class="amen-text">{{ link.text }}</div>
          </div>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      footerColumn1: [{ text: "THE AMENITIES" }],
      footerColumn2: [
        { text: "FLAT-SCREEN SMART TV" },
        { text: "PRIVATE BATHROOM" },
        { text: "NESPRESSO COFFEE MAKER" },
        { text: "HOUSE KEEPING" },
        { text: "BAMBOO BED LINENS" },
      ],
      footerColumn3: [
        { text: "WIFI" },
        { text: "A/C" },
        { text: "BLUETOOTH SPEAKER" },
        { text: "MINI FRIDGE" },
        { text: "WELCOME TREAT" },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/styles/variables";
.amenities {
  padding: 50px 50px 50px 50px;
  @media screen and (max-width: 1176px) {
    padding: 40px 40px 50px 40px;
  }
  a:link,
  a:visited,
  a:hover,
  a:active {
    color: $m-white;
    text-decoration: none;
  }
  .amen-text {
    @media screen and (max-width: 450px) {
      font-size: 13.5px;
    }
  }
}
</style>
